import SimpleCrypto from "simple-crypto-js";
import { dataEncryptKey, defaultColor } from "./constants/defaultValues";

const dataCrypto = new SimpleCrypto(dataEncryptKey);

let savedTheme = localStorage.getItem('theme') || 'light';
let savedThemeColor = localStorage.getItem('themeColor') || defaultColor;

const facility_id_encrypted = localStorage.getItem('facility_id');
if (facility_id_encrypted) {
  try {
    const facility_id = dataCrypto.decrypt(facility_id_encrypted);
    if (facility_id == 13 || facility_id == 14) {
      savedTheme = 'dark';
      savedThemeColor = 'light.orange';
      localStorage.setItem('theme', savedTheme);
      localStorage.setItem('themeColor', savedThemeColor);
    }
  } catch (err) {
    console.warn('Facility ID decryption failed:', err);
  }
}

export default savedThemeColor;
